import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  title,
  content,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  onClose,
  onConfirm,
  loading = false,
  confirmColor = "error",
  maxWidth = "xs",
  fullWidth = false,
}) => {
  return (
    <Dialog
      open={!!open}
      onClose={loading ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {typeof content === "string" ? (
          <Typography>{loading ? "Processando..." : content}</Typography>
        ) : (
          content
        )}
      </DialogContent>
      <DialogActions>
        {!loading && (
          <>
            <Button onClick={onClose}>{cancelText}</Button>
            <Button color={confirmColor} onClick={onConfirm}>
              {confirmText}
            </Button>
          </>
        )}
        {loading && <CircularProgress size={20} sx={{ m: 2 }} />}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
